<template>
    <q-page padding>
        <div class="text-h3 q-mb-md">Ingeniería</div>
        <div ref="supersetContainer" class="embedded-superset"></div>
    </q-page>
</template>

<script setup>
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { ref, onMounted } from "vue";
import SupersetService from "@/services/SupersetService";

const supersetContainer = ref(null);
onMounted(async () => {
    const params = {
        dashboard_id: "1", // the id of the dashboard to embed
        // any other param you want to send to the backend
    };
    const token = await SupersetService.getToken(params);
    embedDashboard({
        id: "7f1a9e39-a14e-486c-bb38-d9b80302d899", // given by the Superset embedding UI
        supersetDomain: "https://bi1.artorisrv.com.ar",
        mountPoint: supersetContainer.value, // any html element that can contain an iframe
        fetchGuestToken: () => token,
        dashboardUiConfig: {
            // dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional), urlParams (optional)
            hideTitle: true,
            filters: {
                expanded: true,
            },
        },
        // optional additional iframe sandbox attributes
        iframeSandboxExtras: [
            "allow-top-navigation",
            "allow-popups-to-escape-sandbox",
        ],
        // optional config to enforce a particular referrerPolicy
        //  referrerPolicy: "same-origin",

    });
});
</script>
<style scoped>
:deep(.embedded-superset) iframe{
    width: 100%;
    height: 80vh;
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow: hidden;
}
</style>
